<template>
   <div style="margin-left: 30px;">
       <product-head :params="params"></product-head>
        <div slot="footer" class="dialog-footer">
            <el-button type=primary @click="handleDialogConfigureShow">确定</el-button>
        </div>
    </div>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>
<script>

import LimitConfigure from  "~/views/order/jiaoben/limitConfigure.vue";
import ProductHead from  "~/views/order/partial/product_head.vue";
export default {
    components:{
        LimitConfigure,
        ProductHead
    },
    data() {
        return {
            form:{
                order_id:'',
                product_id:'',
                limit_configure:{},
            },
            formLabelWidth:'120px',
        };
    },
    props:{

            params:{
                type:Object,
                required:true
            }
    },
    mounted() {
        if(typeof this.params.config != 'undefined'){
            this.form = Object.assign({},this.params.config)
        }
        this.form.order_id = this.params.order_id;
        this.form.product_id = this.params.product_id;
        this.form.type = this.params.open_state;
        this.form.end_at = this.params.end_at;
        this.form.start_at = this.params.start_at;
    },
    methods:{
        handleDialogConfigureShow(){
            this.$emit('handleDialogConfigureShow',this.form);
        },
        handleSubmitLimitConfigure(params){
            console.log(this.form);
            this.form.limit_configure = params;
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/beikeConfigure.vue